<template>
<div class="chapter">
<div class="inner_page">
<div id="_idContainer000">
<h1 class="center">Finches of Mars</h1>
<h3 class="center" style="margin-top:60px;">Brian W. Aldiss</h3>
<p class="center" style="margin-top:80px;"><img alt="image" src="image/logo.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// FinchesofMars_1P.vue?d6cef6de